import { Text } from '@/components/core';
import { CheckmarkIcon, SaveIcon } from '@/components/icons';

export type AutosaveProps = {
  isPending: boolean;
  isSuccess: boolean;
  error: Error | null;
};

export const Autosave = ({ isPending, isSuccess, error }: AutosaveProps) => {
  return (
    <div className="group/autosave flex flex-col">
      {isPending ? (
        <div className="flex flex-row gap-2">
          <Text>Saving</Text>
          <SaveIcon />
        </div>
      ) : isSuccess ? (
        <div className="flex flex-row gap-2">
          <Text variant="success" className="animate-fade opacity-0">
            Saved!
          </Text>
          <CheckmarkIcon variant="success" className="animate-fade opacity-0" />
        </div>
      ) : null}
      <Text>{error ? error.message : null}</Text>
    </div>
  );
};
